/* eslint-disable */
import React, {Component} from 'react';
import { PieChart, Pie, ResponsiveContainer } from 'recharts';
import { Card, Col } from 'reactstrap'; // import { Card, CardBody, Col } from 'reactstrap';
import MapMarkerRadiusIcon from 'mdi-react/MapMarkerRadiusIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {PARKING_SPOTS_TOTAL_LEVEL1_LEVEL2_LEVEL3} from '../../../../constants/dataConstants';
class Distance extends Component {
  constructor(props){
    super(props);
  }

  render(){
    const {t} = this.props;
    
    let statusData = this.props.statusData;

    let totalOccupied = 0;
    let data = [];

    if(statusData){

      if (statusData[0] 
        && statusData[0].attributes 
        && statusData[0].attributes.Level3
        && statusData[0].attributes.Level3.length > 0) {

          const level = statusData[0].attributes.Level3[0];
          if (level.value === null) {
            totalOccupied += 0;
          } else {
            totalOccupied += parseInt(level.value)
          }

        }

      data = [{value: parseInt(this.props.latestCalculateResult.Level3), fill: '#e2a4fc' }, {value: PARKING_SPOTS_TOTAL_LEVEL1_LEVEL2_LEVEL3[3] - parseInt(this.props.latestCalculateResult.Level3), fill: '#ebcbfd'}];
    }

    let percentage = Math.floor((parseInt(this.props.latestCalculateResult.Level3) / (PARKING_SPOTS_TOTAL_LEVEL1_LEVEL2_LEVEL3[3].toFixed(1))) * 100);

    return (
      <Col md={6} xl={3} lg={6} sm={12} xs={12}>
        <Card>
          <div className="card-w dashboard__health-chart-card">
            <div className="card__title">
              <h5 className="bold-text">{t('Level 3 Lot Occupancy')}</h5>
            </div>
            <div className="dashboard__health-chart">
              <ResponsiveContainer height={180}>
                <PieChart>
                  <Pie data={data} dataKey="value" cy={85} innerRadius={78} outerRadius={90} />
                </PieChart>
              </ResponsiveContainer>
              <div className="dashboard__health-chart-info">
                <div style={{height: '15px'}}></div>
                <p style={{color:'#e2a4fc'}} className="dashboard__health-chart-number" >{percentage}%</p>
                <p className="dashboard__health-chart-units">{this.props.latestCalculateResult.Level3}/{PARKING_SPOTS_TOTAL_LEVEL1_LEVEL2_LEVEL3[3]}</p>
                <p className="dashboard__health-chart-units">lots occupied</p>
              </div>
            </div>
          </div>
        </Card>
      </Col>
    )
  }
}

Distance.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(Distance);
